import { render, staticRenderFns } from "./forgot-password-bb.vue?vue&type=template&id=c1db5dd2&scoped=true"
import script from "./forgot-password-bb.vue?vue&type=script&lang=js"
export * from "./forgot-password-bb.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-bb.vue?vue&type=style&index=0&id=c1db5dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1db5dd2",
  null
  
)

export default component.exports